module.exports = __webpack_public_path__ + "img/flutterwave.2cf026ee.png";